import axios from "axios"
import router from '@/router'
import { ElMessage } from "element-plus";
import qs from 'qs'
import { useScreenStore } from '@/stores/index.js'
import utils from '@/utils/index.js'
export default function request (config) {


	console.log(10,config)
	//创建一个axios对象并配置
	const instance = axios.create({
		baseURL: "/apibs", //apibs api 接口
		timeout: 60000,
		// `withCredentials` 表示跨域请求时是否需要使用凭证
		withCredentials: true,
		headers: { 'Content-Type': 'application/json; charset=utf-8' },
		paramsSerializer (params) {
			return qs.stringify(params, { arrayFormat: 'indices', allowDots: true });
		}
	});
	//请求拦截器：在发请求之前请求拦截器可以检测到
	instance.interceptors.request.use(
		(config) => {
			const urlType = useScreenStore().URLTYPE;
			console.log(urlType)
			const type = config.method
			const arrayFormat = config.headers.arrayFormat || 'indices'
			// 根据 urlType 设置 siteId
			let siteId = null
			if (urlType === 'mf') siteId = 6
			if (urlType === 'ebn') siteId = 5
			if (urlType === 'ak') siteId = 7
			if (urlType === 'sbipro') siteId = 8

			if (siteId) {
				if (type === 'get') {
					// 给 GET 请求加参数
					config.params = {
						...(config.params || {}),
						siteId,
					}
				} else if (type === 'post') {
					// 给 POST 请求加参数
					if (
						config.headers['Content-Type'] ===
						'application/x-www-form-urlencoded; charset=utf-8'
					) {
						// 表单格式
						config.data = qs.stringify(
							{
								...(qs.parse(config.data) || {}),
								siteId,
							},
							{ allowDots: true, arrayFormat }
						)
					} else {
						// JSON 等其他格式
						config.data = {
							...(config.data || {}),
							siteId,
						}
					}
				}
			}

			// GET 请求参数序列化
			if (type === 'get') {
				config.paramsSerializer = (params) => {
					return qs.stringify(params, {
						allowDots: true,
						arrayFormat: arrayFormat,
					})
				}
			}
			// 请求头带上当前域名
			config.headers.domain = window.location.hostname
			// const type = config.method
			// const arrayFormat = config.headers.arrayFormat || 'indices'

			return config
		},
		(err) => {
			console.log(err);
		}
	);
	//响应拦截器：返回成功的回调，返回失败的回调
	instance.interceptors.response.use(
		(res) => {
			return res.data;
		},
		(err) => {
			if (err.response && !useScreenStore.updateErrmsg) {
				// 超时自动刷新
				if (err.response.status === 408) {
					ElMessage.error('您的登录已过期，请重新登录')
					utils.clearLoginInfo()
					router.replace({ path: '/index' });
				} else if (err.response.status === 401) {
					ElMessage.error('登录失败!')
					// utils.clearLoginInfo();
					useScreenStore.updateErrmsg = true;
				} else if (err.response.status === 404) {
					ElMessage.error('无效路径');
					router.replace({ path: '/' });
				} else if (err.response.status === 503) {
					ElMessage.error('服务不可用')
				} else if (err.response.status === 504) {
					ElMessage.error('网络连接错误')
				} else if (err.response.status === 400) {
					ElMessage.error('请求失败')
				} else {
					ElMessage.error('系统错误' + err)
				}
			} else {
				if (!useScreenStore.updateErrmsg && err.code === 'ECONNABORTED') {
					ElMessage.error('请求超时，请重新刷新页面')
				}
			}
			useScreenStore.updateErrmsg = true;
			setTimeout(() => {
				useScreenStore.updateErrmsg = false;
			}, 2000);
			return Promise.reject(err);
		}
	);
	return instance(config);
}
